import { Equipment } from '../../Models/Equipment';
import { formatNumbers, renderHTML } from '../../Utils';

export default function ProductSpecs({
  equipment,
}: {
  equipment: Equipment | null | undefined;
}) {
  return (
    <div className='container mx-auto p-4'>
      <div className='text-black'>
        <div className='grid grid-cols-1 gap-4'>
          {/* Categories */}
          <div className='flex flex-col sm:flex-row sm:items-center gap-2'>
            <div className='font-bold w-40'>Categories:</div>
            <div className='text-black'>
              {equipment?.categoriesString &&
                equipment?.categoriesString.map((x) => <div>{x}</div>)}
            </div>
          </div>
          {/* Part Number */}
          <div className='flex flex-col sm:flex-row sm:items-center gap-2'>
            <div className='font-bold w-40'>Part #:</div>
            <div className='text-black'>{equipment?.number ?? 'N/A'}</div>
          </div>

          {/* Description */}
          <div className='flex flex-col sm:flex-row sm:items-center gap-2'>
            <div className='font-bold w-40'>Description:</div>
            <div className='text-black'>{equipment?.description ?? 'N/A'}</div>
          </div>

          {/* Manufacturer */}
          <div className='flex flex-col sm:flex-row sm:items-center gap-2'>
            <div className='font-bold w-40'>Manufacturer:</div>
            <div className='text-black'>
              {equipment?.manufacturer?.name ?? 'N/A'} (
              {equipment?.manufacturer?.rimssOemvendorNumber ?? 'N/A'})
            </div>
          </div>

          {/* Information (Full Description) */}
          <div className='flex flex-col sm:flex-row sm:items-start gap-2'>
            <div className='font-bold w-40'>Information:</div>
            <div className='text-black'>
              {renderHTML(equipment?.fullDescription ?? 'N/A')}
            </div>
          </div>

          {/* Dimensions */}
          <div className='flex flex-col sm:flex-row sm:items-center gap-2'>
            <div className='font-bold w-40'>Height:</div>
            <div className='text-black'>{equipment?.height ?? 'N/A'}</div>
          </div>

          <div className='flex flex-col sm:flex-row sm:items-center gap-2'>
            <div className='font-bold w-40'>Width:</div>
            <div className='text-black'>{equipment?.width ?? 'N/A'}</div>
          </div>

          <div className='flex flex-col sm:flex-row sm:items-center gap-2'>
            <div className='font-bold w-40'>Depth:</div>
            <div className='text-black'>{equipment?.depth ?? 'N/A'}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
